export default __webpack_public_path__ + "static/media/logo.9cb74ba5.png";